import React from 'react';

import { FormattedMessage } from 'react-intl';

import { IntlMsgShape, isIntlMsgShape } from 'helpers/consts';

interface IProps {
  message?: string | IntlMsgShape;
}

const Message = ({ message }: IProps) => {
  if (isIntlMsgShape(message)) {
    return <FormattedMessage {...message} />;
  } else if (message) {
    return <span>{message}</span>;
  } else {
    return <></>;
  }
};

export default Message;
